<template>
    <div>
        <SearchBox/>

        <PagingBox :current="$route.params.page" :max="10"/>

        <div class="flexBox">
            <OfferListBox
                v-for="(item, index) in state.listOffers"
                :key="index"
                :id="item.oferta_id"
                :name="item.oferta_nr"
                :price="item.cena"
                :img="item.zdjecie"
                :obiekt-nazwa="item.obiekt_nazwa"
                :obiekt-transakcja-short="item.transakcja"
                :powierzchnia="item.powierzchnia"
                :lokalizacja="item.lokalizacja"
            />
        </div>

        <PagingBox :current="$route.params.page" :max="10"/>

        <div v-if="showModal" class="modal-route">
            <div class="modal-content">
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
import OfferListBox from "@/components/OfferListBox";
import SearchBox from "@/components/SearchBox";
import PagingBox from "@/components/PagingBox";
import { useState} from "@/state";

export default {
    name: "Search",
    watch: {
        $route: {
            immediate: true,
            handler: function (newVal, oldVal) {
                this.showModal = newVal.meta && newVal.meta.showModal;
            }
        }
    },
    components: { PagingBox, SearchBox, OfferListBox },
    data () {
        return {
            showModal: false,
            state: useState()
        };
    },
    async created () {
        try {
            let response = await fetch(process.env.VUE_APP_XHR, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        mode: 'list',
                        type: 'search',
                        params: {
                            typ: this.state.typ,
                            rodzaj: this.state.rodzaj,
                            miejscowosc: this.state.miejscowosc,
                            dzielnica: this.state.dzielnica,
                            powierzchniaOd: this.state.powierzchniaOd,
                            powierzchniaDo: this.state.powierzchniaDo,
                            cenaOd: this.state.cenaOd,
                            cenaDo: this.state.cenaDo,
                            strona: this.state.strona
                        },
                        page: this.$route.params.page || 1
                    })
                }
            )
            this.state.listOffers = await response.json();
        } catch (err) {
            console.log(err)
        }
    }
}
</script>

<style lang="scss" scoped>
.flexBox {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;

    > div {
        flex-shrink: 1;
        flex-grow: 1;
        flex-basis: auto;
    }
}

.modal-route {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background: rgba(#000000, 0.1);
    backdrop-filter: blur(10px);

    .modal-content {
        padding: 10px;
        width: 900px;
        height: 90vh;
        background-color: #fff;
        border: solid 1px #eeeeee;
        box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
    }
}

@media all and (max-width:800px) {
    .modal-route .modal-content {
        width: 100vw;
        height: 100vh;
    }
}
</style>